// extracted by mini-css-extract-plugin
export var optionalModules = "optional-modules-module--optionalModules--I8jrN";
export var backgroundImage = "optional-modules-module--backgroundImage--PbrBY";
export var modules = "optional-modules-module--modules--2F10s";
export var textModule = "optional-modules-module--textModule--3zTRT";
export var mediaModule = "optional-modules-module--mediaModule--ogzrE";
export var mediaModuleMedia = "optional-modules-module--mediaModuleMedia--1QqzP";
export var mediaModuleCopyColumn = "optional-modules-module--mediaModuleCopyColumn--iIUhm";
export var textModuleHeader = "optional-modules-module--textModuleHeader--2c-fT";
export var link = "optional-modules-module--link--2txA0";